var _defs, _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 19,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Icon awesome-phone"), /*#__PURE__*/React.createElement("path", {
    d: "M17.58735,1.72012l-3.70701,-0.85546c-0.40278,-0.09268 -0.81625,0.11763 -0.98022,0.49546l-1.71093,3.99216c-0.14971,0.34931 -0.0499,0.75922 0.24595,0.99804l2.16004,1.76796c-1.2832,2.73392 -3.52522,5.00803 -6.31617,6.31617l-1.76796,-2.16004c-0.24238,-0.29585 -0.64873,-0.39565 -0.99804,-0.24595l-3.99216,1.71093c-0.38139,0.16753 -0.5917,0.581 -0.49902,0.98378l0.85546,3.70701c0.08911,0.38496 0.4313,0.66298 0.83408,0.66298c9.12851,0 16.53896,-7.39619 16.53896,-16.53896c0,-0.39922 -0.27446,-0.74497 -0.66298,-0.83408z",
    fill: "currentColor",
    fillOpacity: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPhone);
export default __webpack_public_path__ + "static/media/map-phone.089e0c82.svg";
export { ForwardRef as ReactComponent };